export default "__VITE_ASSET__3aa146c3__"